import { useTranslation } from 'react-i18next';

export const colors = {
    pending: 'blue',
    incomplete: 'gray',
    external: 'orange',
    declined: 'red',
    validated: 'green'
};

export const statusType = {
    PENDING: 'pending',
    INCOMPLETE: 'incomplete',
    EXTERNAL: 'external',
    DECLINED: 'declined',
    VALIDATED: 'validated'
};

export const exportFilesStatusType = {
    building: 'grey',
    ready: 'blue',
    screening: 'orange',
    complete: 'green',
    error: 'red'
};

export const importFilesStatusType = {
    ready: 'blue',
    error: 'red',
    upload: 'grey',
    processing: 'yellow',
    done: 'green'
};

// Duplicate mapping to comply with Aws and Sarbacane events names
export const mailStatusColors = {
    click: 'purple',
    clicked: 'purple',
    delivered: 'green',
    delivery: 'green',
    hardbounce: 'red',
    hardbounced: 'red',
    sent: 'grey',
    send: 'grey',
    open: 'blue',
    opened: 'blue',
    softbounce: 'orange',
    softbounced: 'orange'
};

// Duplicate mapping to comply with Aws and Sarbacane events names
export const mailStatusPriorities = {
    click: 1,
    clicked: 1,
    open: 2,
    opened: 2,
    delivery: 3,
    delivered: 3,
    sent: 4,
    send: 4,
    softbounce: 5,
    softbounced: 5,
    hardbounce: 5,
    hardbounced: 5
};

export const exportStatusFilterOptions = () => {
    const { t } = useTranslation();

    return Object.keys(exportFilesStatusType).map(status => ({
        text: t(`ticket.moderation.filesManagement.status.${status}`),
        name: status,
        key: exportFilesStatusType[status]
    }));
};

export const importStatusFilterOptions = () => {
    const { t } = useTranslation();

    return Object.keys(importFilesStatusType).map(status => ({
        text: t(`ticket.moderation.filesManagement.status.${status}`),
        name: status,
        key: importFilesStatusType[status]
    }));
};

export const attendeeStatusFilterOptions = () => {
    const { t } = useTranslation();

    return Object.values(statusType).map(value => ({
        text: t(`ticket.moderation.common.status.${value}`),
        name: value,
        key: statusType[value]
    }));
};

export const formatMailStatus = event => event.toLowerCase().replace('-', '');

export const getMailStatus = event => {
    const status = formatMailStatus(event);
    return mailStatusColors[status];
};

export const getMailStatusPriority = event => {
    const status = formatMailStatus(event);
    return mailStatusPriorities[status];
};
